import script from "./CaskVideoCollection.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskVideoCollection.vue?vue&type=script&setup=true&lang=js"

import "./CaskVideoCollection.vue?vue&type=style&index=0&id=0ea4cc2a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ea4cc2a"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSeparator});
